export default __webpack_public_path__ + "static/media/sipmenu-cancel.04529323.svg";